module.exports = __webpack_public_path__ + "static/payroll-8556e757729ad2922eaa1ab488cb6bc2.svg";